import { BaseController } from '../../../../common/base/controller';
import _ from 'lodash';

export class HistoryEntryListController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({
      controllerService,
    });
  }

  getEventInitiator(initiator) {
    if (!_.isString(initiator)) return initiator;

    const lowerCase = initiator.toLowerCase();

    // get rid of internal intiators
    if (lowerCase.includes('digital.fino') || lowerCase.includes('cyclops'))
      return 'sidebar.section.history.initiatedBySystem';
    return initiator;
  }
}
